import React, { Component } from 'react';

export class Button extends Component {
    displayName = Button.name

    constructor(props) {
        super(props);
    }

    render() {
        let buttonStyle = ( this.props.loading && (this.props.skin  == "primary")) ? { color: "#fff" } : {};
        return (
            <button disabled={this.props.loading}
                type={this.props.type}
                style={{ cursor: "pointer", ...buttonStyle }}
                className={"btn btn-" + this.props.skin + " btn-" + this.props.size}
                onClick={() => this.props.onClick()}>
                {this.props.value} {this.props.loading && <i className="fas fa-spinner fa-spin"></i>}
            </button>
        );
    }
}

Button.defaultProps = {
    type: "button",
    skin: "primary",
    size: "lg",
    onClick: () => { },
    loading: false,
    value: "save"
}


// WEBPACK FOOTER //
// ./src/components/Button.js